var map = {
	"./index.ts": 49,
	"./primitives": 6,
	"./primitives.js": 6,
	"./tools": 5,
	"./tools.js": 5
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;



/*****************
 ** WEBPACK FOOTER
 ** ./tests ^\.\/.*$
 ** module id = 47
 ** module chunks = 1
 **/